import { initials } from '@/ui/format';
/**
 * People to choose between, one row each (#154 UI01-10): the approved planning option row adapted to
 * a person, with their initials, their name and the one-line reason. The row is the one control, a
 * radio: choosing it is the same draft-only choice the old «Velg» made. Order, reasons and what is
 * offered are the caller's; nothing here ranks, scores or saves.
 */
import { Icon } from '@/ui/icons';
import s from './PersonOptions.module.css';

export type PersonOption = { id: number; name: string; reason: string; review?: boolean };

export function PersonOptions({
  legend,
  name,
  options,
  selected,
  onSelect,
  disabled,
  testid,
}: {
  legend: string;
  /** the radio group's name, unique on the page */
  name: string;
  options: PersonOption[];
  selected: number | null;
  onSelect: (id: number) => void;
  disabled?: boolean;
  testid?: string;
}) {
  return (
    <fieldset className={s.options} data-testid={testid} disabled={disabled}>
      <legend>{legend}</legend>
      {options.map((o) => (
        <label key={o.id} className={s.option} data-testid={testid ? `${testid}-option` : undefined}>
          <input type="radio" name={name} checked={selected === o.id} onChange={() => onSelect(o.id)} />
          <span className={s.avatar} aria-hidden="true">
            {initials(o.name)}
          </span>
          <span className={s.copy}>
            <span className={s.name}>{o.name}</span>
            <span className={`${s.reason}${o.review ? ` ${s.review}` : ''}`}>
              {o.review ? <Icon name="warn" /> : null}
              {o.reason}
            </span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
